export default __webpack_public_path__ + "static/b4-fb4a21fcec36d2e2282a6dae562f60f9.jpg";